import React from "react";
import "../../../css/WeekTimeRental.css";
import { PieChart, Pie, Tooltip, ResponsiveContainer } from "recharts";

interface WeekTimeRentalProps {
  WeekTimeRental: { time: string; count: number }[];
}

const WeekTimeRental: React.FC<WeekTimeRentalProps> = ({ WeekTimeRental }) => {
  return (
    <div className="time_container">
      <h2 className="time_title">時間別レンタル割合(直近7日間)</h2>
      <ResponsiveContainer width="100%" height="75%">
        <PieChart className="Piechart">
          <Pie
            data={WeekTimeRental}
            dataKey="count"
            nameKey="time"
            cx="50%"
            cy="50%"
            outerRadius={80}
            fill="#82ca9d"
            label
          />
          <Tooltip />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};

export default WeekTimeRental;
